export class UserPermissionResponse {
  userId: number; 
  emailId: string;
  eloviewVersionId: number;
  enableGatewaySync: boolean;
  enableProvisioningSync: boolean;
  enableEloViewSync: boolean;  
  enableEDIOrder: boolean;
  enableBldDetailsUpdate: boolean;
  defaultGatewayTypeId : number;  
  defaultEloviewVersionId: number;
  isActive: boolean;
}
